<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && loginUser()?.profile_img_url) {
        <img class="h-7 w-7 rounded-full" [src]="imageUrl" />
        }
        @if (!showAvatar || !loginUser()?.profile_img_url) {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <span class="absolute bottom-0 right-0 h-2 w-2 rounded-full" [ngClass]="{
                'mb-px mr-px': !showAvatar || !loginUser()?.profile_img_url,
                'bg-green-500': status() === 'online',
                'bg-amber-500': status() === 'away',
                'bg-red-500': status() === 'busy',
                'bg-gray-400': status() === 'not-visible',
            }"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    @if (loginUser()) {
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ loginUser()!.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="['apps/profile', loginUser()!.oid]">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:davesa-c'"></mat-icon>
        <span>Sign out</span>
    </button>
    }
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userTheme="matMenu">
    <button mat-menu-item (click)="setScheme('light')">
        <!-- <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span> -->
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:sun'"></mat-icon>
        <span>Light</span>
    </button>
    <button mat-menu-item (click)="setScheme('dark')">
        <!-- <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span> -->
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:moon'"></mat-icon>
        <span>Dark</span>
    </button>
    <button mat-menu-item (click)="setScheme('auto')">
        <!-- <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span> -->
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:bolt'"></mat-icon>
        <span>Auto</span>
    </button>
</mat-menu>